var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.22703 6.22703C7.4929 4.96116 9.20979 4.25 11 4.25C12.7902 4.25 14.5071 4.96116 15.773 6.22703C17.0388 7.4929 17.75 9.20979 17.75 11C17.75 11.8864 17.5754 12.7642 17.2362 13.5831C16.9931 14.1701 16.6688 14.7186 16.2737 15.2131L19.5303 18.4697C19.8232 18.7626 19.8232 19.2374 19.5303 19.5303C19.2374 19.8232 18.7626 19.8232 18.4697 19.5303L15.2131 16.2737C14.7186 16.6688 14.1701 16.9931 13.5831 17.2362C12.7642 17.5754 11.8864 17.75 11 17.75C10.1136 17.75 9.23584 17.5754 8.41689 17.2362C7.59794 16.897 6.85382 16.3998 6.22703 15.773C5.60023 15.1462 5.10303 14.4021 4.76381 13.5831C4.42459 12.7642 4.25 11.8864 4.25 11C4.25 9.20979 4.96116 7.4929 6.22703 6.22703ZM11 5.75C9.60761 5.75 8.27226 6.30312 7.28769 7.28769C6.30312 8.27226 5.75 9.60761 5.75 11C5.75 11.6894 5.8858 12.3721 6.14963 13.0091C6.41347 13.646 6.80018 14.2248 7.28769 14.7123C7.7752 15.1998 8.35395 15.5865 8.99091 15.8504C9.62787 16.1142 10.3106 16.25 11 16.25C11.6894 16.25 12.3721 16.1142 13.0091 15.8504C13.646 15.5865 14.2248 15.1998 14.7123 14.7123C15.1998 14.2248 15.5865 13.646 15.8504 13.0091C16.1142 12.3721 16.25 11.6894 16.25 11C16.25 9.60761 15.6969 8.27226 14.7123 7.28769C13.7277 6.30312 12.3924 5.75 11 5.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.067a5e49b7dc1bb9f0cbe5576acaa603.svg";
export { ForwardRef as ReactComponent };